import { render } from "./DeliveryNoteCreateClaim.vue?vue&type=template&id=35d9991f"
import script from "./DeliveryNoteCreateClaim.vue?vue&type=script&lang=js"
export * from "./DeliveryNoteCreateClaim.vue?vue&type=script&lang=js"

import "./DeliveryNoteCreateClaim.vue?vue&type=style&index=0&id=35d9991f&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__